import React, { useCallback, } from 'react';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { layout, } from 'styles';

type Props = {
    amount: number,
    setOpenPopper: Function,
};

const ShoppingCartHeader: React.FC<Props> = ({
    amount,
    setOpenPopper,
}) => {
    const headerClasses = layout.makeCartShopHeaderStyles();
    const closeHandler = useCallback(() => setOpenPopper(false), [ setOpenPopper, ]);

    return (
        <AppBar position="static"
                classes={headerClasses}>
            <Toolbar>
                <Grid container
                      justify="space-between"
                      alignItems="center">
                    <Typography variant="body1">
                        {amount ? `Zawartość koszyka (${amount} egz.)` : 'Twój koszyk jest pusty'}
                    </Typography>
                    <IconButton color="inherit"
                                onClick={closeHandler}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </Toolbar>
        </AppBar>
    );
};

export default ShoppingCartHeader;
